<template>
  <header class="site-header" :class="{scrolled: scrolled}">
    <div class="container">
      <div class="logo-name">
        <div class="logo">R</div>
        <div class="name">
          <h1>{{ name }}</h1>
          <p>Frontend Developer</p>
        </div>
      </div>

      <nav class="nav-desktop">
        <ul>
          <li v-for="item in navItems" :key="item.text">
            <a :href="item.link" :class="{active: item.active}">{{ item.text }}</a>
          </li>
        </ul>
      </nav>

      <a href="#contact" class="contact-btn">Связаться</a>

      <button class="menu-toggle" @click="toggleMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="mobile-menu" v-if="mobileMenuOpen">
        <div class="mobile-menu-header">
          <div class="logo small">R</div>
          <button class="close-btn" @click="toggleMobileMenu">✕</button>
        </div>
        <nav class="nav-mobile">
          <a 
            v-for="item in navItems" 
            :key="item.text" 
            :href="item.link"
            :class="{active: item.active}"
            @click="toggleMobileMenu"
          >
            {{ item.text }}
          </a>
        </nav>
        <a href="#contact" class="mobile-contact-btn" @click="toggleMobileMenu">Связаться</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      name: 'Ruslan Abkadirov',
      mobileMenuOpen: false,
      scrolled: false,
      navItems: [
        { text: 'Главная', link: '#home', active: true },
        { text: 'Обо мне', link: '#about', active: false },
        { text: 'Услуги', link: '#services', active: false },
        { text: 'Портфолио', link: '#portfolio', active: false },
        { text: 'Отзывы', link: '#testimonials', active: false }
      ]
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 20;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
    }
  }
}
</script>

<style scoped>
/* Базовые стили */
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: #ffffff;
  transition: all 0.3s ease;
  padding: 15px 0;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.site-header.scrolled {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Логотип и имя */
.logo-name {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo {
  width: 40px;
  height: 40px;
  background-color: #2c3e50;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.logo.small {
  width: 32px;
  height: 32px;
  font-size: 16px;
}

.name h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.name p {
  margin: 0;
  font-size: 12px;
  color: #5a7184;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

/* Навигация */
.nav-desktop {
  display: none;
}

@media (min-width: 768px) {
  .nav-desktop {
    display: block;
  }
}

.nav-desktop ul {
  display: flex;
  list-style-type: none;
  padding: 0;
  margin: 0;
  gap: 30px;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.nav-desktop a {
  color: #5a7184;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  transition: color 0.3s;
  padding-bottom: 3px;
  position: relative;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.nav-desktop a:hover {
  color: #2c3e50;
}

.nav-desktop a::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3498db;
  transition: width 0.3s;
}

.nav-desktop a:hover::after, 
.nav-desktop a.active::after {
  width: 100%;
}

.nav-desktop a.active {
  color: #2c3e50;
  font-weight: 600;
}

/* Кнопка контакта */
.contact-btn {
  display: none;
}

@media (min-width: 768px) {
  .contact-btn {
    display: block;
    background-color: #3498db;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s;
    font-family: 'Arial', 'Helvetica', sans-serif;
  }

  .contact-btn:hover {
    background-color: #2980b9;
    transform: translateY(-2px);
  }
}

/* Кнопка мобильного меню */
.menu-toggle {
  display: flex;
  flex-direction: column;
  gap: 5px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
}

@media (min-width: 768px) {
  .menu-toggle {
    display: none;
  }
}

.menu-toggle span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: #2c3e50;
  transition: all 0.3s;
}

/* Мобильное меню */
.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 270px;
  height: 100vh;
  background-color: white;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 200;
  display: flex;
  flex-direction: column;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #2c3e50;
  cursor: pointer;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.nav-mobile {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.nav-mobile a {
  color: #5a7184;
  text-decoration: none;
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 6px;
  transition: all 0.3s;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.nav-mobile a:hover {
  background-color: #f5f9fc;
  color: #2c3e50;
}

.nav-mobile a.active {
  background-color: #f5f9fc;
  color: #2c3e50;
  font-weight: 600;
  border-left: 3px solid #3498db;
}

.mobile-contact-btn {
  margin-top: auto;
  background-color: #3498db;
  color: white;
  text-align: center;
  padding: 12px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  margin-top: 20px;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.mobile-contact-btn:hover {
  background-color: #2980b9;
}
</style>